import { DependentMappings } from '@components/field-mapperV2/field-mapperV2'
import { DefaultMappings, FieldMappingType } from '@components/field-mapperV2/utils'
import { IntegrationFieldBuilder } from './integration-field-builder'
import { FieldMappingFieldConfig } from '../integration-form-types/integration-field-config'
import { IntegrationFormField } from '../integration-form-types/integration-form-field'
import { SupportedFormFields } from '../integration-form-types/supported-form-field-types'

interface FieldMappingField extends IntegrationFormField {
  config: FieldMappingFieldConfig
}

export class FieldMappingBuilder extends IntegrationFieldBuilder {
  field: SupportedFormFields = 'field_mapping'

  config: FieldMappingFieldConfig = {
    placement: 0,
    integrationTitle: '',
    mappingType: 'inbound',
    includeCreativeClassification: false,
  }

  placement(placement: number): this {
    this.config.placement = placement
    return this
  }

  isHidden(hidden: boolean | undefined): this {
    this.config.isHidden = hidden
    return this
  }

  integrationTitle(title: string): this {
    this.config.integrationTitle = title
    return this
  }

  mappingType(mappingType: FieldMappingType): this {
    this.config.mappingType = mappingType
    return this
  }

  integrationFieldsFilter(filter: (field: any) => boolean): this {
    this.config.integrationFieldsFilter = filter
    return this
  }

  mappingsDisabled(disabled: boolean | undefined): this {
    this.config.mappingsDisabled = disabled
    return this
  }

  dependentMappings(mappings: DependentMappings | undefined): this {
    this.config.dependentMappings = mappings
    return this
  }

  defaultMappings(mappings: DefaultMappings | undefined): this {
    this.config.defaultMappings = mappings
    return this
  }

  dataType(type: string | undefined): this {
    this.config.dataType = type
    return this
  }

  includeCreativeClassification(include: boolean | undefined): this {
    this.config.includeCreativeClassification = include
    return this
  }

  build(): FieldMappingField {
    const fieldMappingField: FieldMappingField = {
      field: this.field,
      config: this.config,
    }

    if (!this.verifyBuiltField(fieldMappingField)) {
      console.error('Error in the config sent to Field Mapping Builder.')
    }

    return fieldMappingField
  }

  verifyBuiltField(field: FieldMappingField): boolean {
    if (field.field !== 'field_mapping') {
      return false
    }

    if (
      field.config.mappingType !== 'inbound' &&
      field.config.mappingType !== 'outbound' &&
      field.config.mappingType !== 'supplemental'
    ) {
      return false
    }

    if (typeof field.config.integrationTitle !== 'string') {
      return false
    }

    if (field.config.integrationTitle == '') {
      console.error(
        'The Field Mapping builder cannont have an empty string as the value for the integrationTitle. Use the integrationTitle builder call to set this value.',
      )
      return false
    }

    return true
  }
}
